import React, { useEffect, useState } from 'react';
import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';
//import { ConfidentialClientApplication } from '@azure/msal-node';
import { handleAuth2RedirectUri } from '../../shared/UtilityFunctions';
import { MessageBarType } from '@fluentui/react';

let timeoutRef;

export default function AuthHome() {
	const [childMessage, setChildMessage] = useState('');

	const handleWindowPopup = () => {
		const windowProps = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, width=500, height=600`;
		const popup = window.open(
			`${window.location.origin}${window.location.pathname}#/popup`,
			'Pop up window',
			windowProps,
		);
		popup.onload = function () {
			popup.postMessage({ name: 'John', age: 30 }, '*');
		};
		popup?.postMessage('message', 'https://localhost:3000/taskpane.html');
	};

	const handleOfficePopup = (tenantID, clientId, scope) => {
		let dialog;
		Office.context.ui.displayDialogAsync(
			`${window.location.origin}${window.location.pathname}#/window?tenantId=${encodeURIComponent(
				'e6228cf6-a777-498f-b358-3f9b0efaba41',
			)}&clientId=${encodeURIComponent('c371b35c-b9ba-43aa-9629-c33a2860d0a7')}&scope=${encodeURIComponent(
				'api://outlook.cmicglobaldev.com/Access.Mail',
			)}`,
			{ height: 0, width: 0 },

			function (asyncResult) {
				dialog = asyncResult.value;
				function processMessage(arg) {
					console.log('arg', JSON.parse(arg.message));
					dialog.close();
					return JSON.parse(arg.message);
				}
				dialog.addEventHandler(Office.EventType.DialogMessageReceived, processMessage);
			},
		);
	};

	useEffect(() => {
		const childResponse = event => {
			if (event?.data) {
				setChildMessage(event.data);
				console.log(event);
			}
		};
		window.addEventListener('message', childResponse);
		//   return () => window.removeEventListener("message", childResponse);
	}, []);

	return (
		<div className="App" style={{ color: 'white' }}>
			<h1> Parent Window </h1>
			<button onClick={handleWindowPopup}>window Popup </button>
			<button onClick={handleOfficePopup}>Office Popup</button>
		</div>
	);
}

export const handleWindowPopup = serverType => {
	const windowProps = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, width=500, height=600`;
	const popup = window.open(
		`${window.location.origin}${window.location.pathname}#/popup`,
		'Pop up window',
		windowProps,
	);
	popup.onload = function () {
		popup.postMessage({ serverType: serverType }, '*');
	};
	popup?.postMessage('message', '*');
};

export const handleOfficePopup = serverType => {
	return new Promise(resolve => {
		console.log(serverType);
		let dialog;
		Office.context.ui.displayDialogAsync(
			`${window.location.origin}${window.location.pathname}#/window?tenantId=${encodeURIComponent(
				serverType.data?.tenantId,
			)}&clientId=${encodeURIComponent(serverType.data?.clientId)}&scope=${encodeURIComponent(serverType.data?.scope)}`,
			{ height: 0, width: 0 },

			function (asyncResult) {
				dialog = asyncResult.value;
				function processMessage(arg) {
					console.log('arg', JSON.parse(arg.message));
					dialog.close();
					resolve(JSON.parse(arg.message));
				}
				dialog.addEventHandler(Office.EventType.DialogMessageReceived, processMessage);
			},
		);
	});
};

export const authenticateUser = (serverType, setIsLoading, setShowToast, removeToast) => {
	return new Promise(async resolve => {
		const msalConfig = {
			auth: {
				clientId: serverType.data?.clientId,
				redirectUri: handleAuth2RedirectUri(),
				authority: `https://login.microsoftonline.com/${serverType.data?.tenantId}`,
				// grant_type: "authorization_code",
			},
			cache: {
				cacheLocation: 'sessionStorage',
				storeAuthStateInCookie: false,
			},
		};

		const msalInstance = new PublicClientApplication(msalConfig);

		try {
			await msalInstance.initialize();

			const data = await msalInstance.loginPopup({ scopes: [`${serverType.data?.scope}`] });

			resolve({ ...data });
		} catch (error) {
			setIsLoading(false);
			setShowToast({
				isVisible: true,
				msg: 'Unable to Sign In' || 'Something went wrong!',
				type: MessageBarType.error,
			});

			clearTimeout(timeoutRef);
			timeoutRef = removeToast(5000);
			console.error('Login error:', error);
		}
	});
};

export const getEmailDataFromMSGraph = (serverType, setIsLoading, setShowToast, removeToast) => {
	return new Promise(async resolve => {
		console.log(serverType);
		const msalConfig = {
			auth: {
				clientId: serverType.data?.clientId,
				redirectUri: handleAuth2RedirectUri(),
				authority: `https://login.microsoftonline.com/${serverType.data?.tenantId}`,
				// grant_type: "authorization_code",
			},
			cache: {
				cacheLocation: 'sessionStorage',
				storeAuthStateInCookie: false,
			},
		};

		const msalInstance = new PublicClientApplication(msalConfig);

		try {
			await msalInstance.initialize();
			const data = await msalInstance.loginPopup({ scopes: ['Mail.Read'] });
			resolve({ ...data });
		} catch (error) {
			console.log(error);
			setIsLoading(false);
		}
	});
};

// export const callMSGraphAPIUSingAccessToken = async (accessToken) => {
//   console.log(Office.context.mailbox.item);
//   const item = Office.context.mailbox.item;

//    let messageId =item?.itemId;
//    let attachmentId = "AQMkADVhMWQyNGMzLWNhZjQtNGM0OC05N2YyLWVkODkwMmI1ZWM4NwBGAAAD3TMlOxe9DEeQxXOoXApfDgcAkJPG8jDIAkCO3zQOOkEjxgAAAgEJAAAAkJPG8jDIAkCO3zQOOkEjxgABQRdxcgAAAAESABAABv7RzhJBfkmNTcSD1AZFlw==";

//     const graphEndpoint = `https://graph.microsoft.com/v1.0/me/messages/${messageId}/attachments/${attachmentId}`;

//     const headers = new Headers();
//     headers.append('Authorization', `Bearer ${accessToken}`);
//     headers.append('Content-Type', 'application/json');

//     try {
//         const response = await fetch(graphEndpoint, {
//             method: 'GET',
//             headers: headers
//         });
//         console.log("response", response);

//         if (response.ok) {
//             const attachmentData = await response.json();
//             console.log("attachmentData", attachmentData);
//             return attachmentData;
//         } else {
//             console.error('Error fetching attachment data:', response.statusText);
//             throw new Error(`HTTP Error: ${response.statusText}`);
//         }
//     } catch (error) {
//         console.error('Error:', error);
//         throw error;
//     }

// }

export const getMessages = async accessToken => {
	const graphEndpoint1 = 'https://graph.microsoft.com/v1.0/me';
	const graphEndpoint2 = 'https://graph.microsoft.com/v1.0/me/messages';
	const graphEndpoint3 = `https://graph.microsoft.com/v1.0/me/messages/${Office.context?.mailbox?.item?.itemId}/$value`;

	console.log(accessToken);
	const headers = new Headers();
	headers.append('Authorization', `Bearer ${accessToken}`);
	headers.append('Content-Type', 'application/json');
	console.log(Office.context?.mailbox?.item);

	try {
		const response1 = await fetch(graphEndpoint1, {
			method: 'GET',
			headers: headers,
		});
		const response2 = await fetch(graphEndpoint2, {
			method: 'GET',
			headers: headers,
		});

		const response3 = await fetch(graphEndpoint3, {
			method: 'GET',
			headers: headers,
		});

		const messageId =
			'AQMkAGMzZTNiM2MwLTcyMzAtNDZlZi05NmJkLWMzZDAwAWYzYWVmOABGAAADuNlwVWw7kkO9dNal69jrfwcAvXujRj_AIEemLIeV5yS8WQAB26l8AAABvXujRj_AIEemLIeV5yS8WQADefTZ_wAAAA==';

		const response4 = await fetch(`https://graph.microsoft.com/v1.0/me/messages/${messageId}`, {
			method: 'GET',
			headers: headers,
		});

		console.log(response1);
		console.log(response2);
		console.log(response3);
		console.log(response4);
		if (response1.ok) {
			const messages = await response1.json();
			console.log(messages);
			return messages.value; // Array of message objects
		} else {
			console.error('Error fetching messages:', response1);
			throw new Error(`HTTP Error: ${response1.statusText}`);
		}
	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
};

export const getAccessTokenViaAuthContext = async ({ clientId }) => {
	console.log('ClientId', clientId);
	Office.auth
		.getAuthContext()
		.then(async authContext => {
			console.log('Auth context retrieved:', authContext);

			const msalConfig = {
				auth: {
					clientId: clientId,
					authority: `https://login.microsoftonline.com/${authContext.tenantId}`,
					redirectUri: handleAuth2RedirectUri(),
				},
			};

			const msalInstance = new PublicClientApplication(msalConfig);
			await msalInstance.initialize();

			// Optional: Set the active account in MSAL
			const account = {
				homeAccountId: authContext.accountIdentifier,
				environment: 'login.microsoftonline.com',
				tenantId: authContext.tenantId,
				username: authContext.userPrincipalName,
			};
			msalInstance.setActiveAccount(account);

			const tokenRequest = {
				scopes: ['User.Read', 'Mail.Read'],
				account: account,
			};

			msalInstance
				.acquireTokenSilent(tokenRequest)
				.then(async response => {
					console.log('Access token acquired silently:', response.accessToken);
					await getMessages(response.accessToken);

					let _strAPIURL = '';
					_strAPIURL = `https://mob6dmz.cmicglobal.com/cmicdevv12/cmic-field-rest-api/jersey/v1/api-info`;

					try {
						const result = await axios.get(_strAPIURL, {
							headers: {
								Authorization: `Bearer ${response.accessToken}`,
							},
						});
						console.log(result);
					} catch (error) {
						console.log(error);
					}
					// Use the token to call Microsoft Graph API
				})
				.catch(error => {
					if (error instanceof InteractionRequiredAuthError) {
						// Handle interactive authentication
						console.warn('Silent token acquisition failed, prompting user for interaction...');
						msalInstance
							.loginPopup(tokenRequest)
							.then(async response => {
								console.log('Access token acquired interactively:', response.accessToken);
								// Use the token to call Microsoft Graph API
								await getMessages(response.accessToken);
							})
							.catch(popupError => {
								console.error('Interactive token acquisition failed:', popupError);
							});
					} else {
						console.error('Silent token acquisition error:', error);
					}
				});
		})
		.catch(error => {
			console.error('Failed to get auth context:', error);
		});
};

export const callBackendWebAPI = async accessTokenA => {
	return new Promise(async resolve => {
		try {
			const result = await axios.post('http://localhost:8888/gettoken', {
				withCredentials: true,
				token: accessTokenA,
			});
			resolve(result);
		} catch (error) {
			console.log(error);
			resolve({ error: 'something went wrong!!!' });
		}
	});
};

export const getAuthTokenForAuthCode = async () => {
	try {
		const tokenUrl = `https://login.microsoftonline.com/0f09972d-7e48-4deb-a2d9-28dcee7dea82/oauth2/v2.0/token`;
		const code = localStorage.getItem('authCode');
		const redirectUri = handleAuth2RedirectUri();
		const codeVerifier = localStorage.getItem('code_verifier');

		const response = await axios.post(
			tokenUrl,
			new URLSearchParams({
				client_id: 'b7ff582c-bb55-4a68-b79e-2e59caa7b6bf',
				grant_type: 'authorization_code',
				code: code,
				redirect_uri: redirectUri + '/taskpane.html',
				code_verifier: codeVerifier,
			}).toString(),
			{ headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
		);
		return response?.data;
	} catch (error) {
		console.log(error);
		return error;
	}
};

export const storeTenantData = async accessTokenB => {
	// Access token obtained using MSAL or Office API

	// Azure AD App ID
	const appId = 'b7ff582c-bb55-4a68-b79e-2e59caa7b6bf';

	// Define a new directory extension
	async function createExtensionProperty() {
		const url = `https://graph.microsoft.com/v1.0/applications/${appId}/extensionProperties`;

		const extensionData = {
			name: 'customProperty1', // Name of the extension property
			dataType: 'String', // Supported types: String, Binary, Boolean, or Int
			targetObjects: ['User'], // Supported objects: User, Group, Device, Organization
		};

		try {
			const response = await axios.post(url, extensionData, {
				headers: {
					Authorization: `Bearer ${accessTokenB}`,
					'Content-Type': 'application/json',
				},
			});
			console.log('Extension property created:', response.data);
			return response.data;
		} catch (error) {
			console.error('Error creating extension property:', error.response.data);
		}
	}

	// Call the function
	createExtensionProperty();
};
